export default __webpack_public_path__ + "locales/pt-BR/ChangeUserTypeDialog.json?hash=ae81a4a91f477a4deb004e34d7cc72ec";